import React, { useState, useEffect, useMemo } from "react";
import { api } from "../../../api";
import { useQuery } from "react-query";
import Card from "../dashboard/components/Card";
import { exams as examsApi } from "../../../api/exams";
import { useTranslation } from 'react-i18next';
import Loader from "../../../components/loader/Loader";
import Pagination from "../../../components/Pagination/Pagination";
import Input from "../../../components/input/Input";
import EmptyData from "../../../components/EmptyData";
import SurveyCard from "../dashboard/components/SurveyCard";
const SelfReview = ({ width }) => {
  const storedBranding = useMemo(() => {
    try {
      return JSON.parse(sessionStorage.getItem("branding"));
    } catch (error) {
      return null;
    }
  }, []);
  const appearance = storedBranding?.data?.appearance;

  const [showRedirect, hideRedirect] = useState(false);
  const user = JSON.parse(sessionStorage.getItem('user'))
  const { t, i18n: i18nNext, } = useTranslation();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(30);
  const [search, setSearch] = useState('')

  const { isLoading: surveysLoading, data: surveys, refetch } = useQuery(
    ["user exams", currentPage, perPage, search],
    async () => {
      const data = await examsApi.getSurveys({
        type: null, id: user?.user?.user_id, currentPage, perPage, search
      });
      return data;
    },
    {
      select: (data) => data,
      refetchOnWindowFocus: false,
    }
  );

  const { data: summaryData, isLoading: summaryLoading } = useQuery(
    ["Self survey Summary Data"],
    async () => {
      const data = await api.getDashboardSummary(user?.user?.user_id);
      return data;
    },
    {
      select: (response) => response?.data,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    }
  );

  useEffect(() => {
    hideRedirect(true);
  }, []);

  return (
    <React.Fragment>
      {(
        <>
          {/*( showRedirect && mockAssessment?.length) ? 
               <Redirect handleRedirect={hideRedirect} /> : null 
           */}
          <h1
            className="text-white rounded-lg shadow bg-primary py-4 px-3 pt-4"
            style={{ fontSize: "20px", marginTop: "0px", backgroundColor: appearance?.theme_colour }}
          >
            Self Evaluations
          </h1>
          <p className="text-gray-600 text-lg mt-2">
            Complete Your self assessments for current feedback cycles
          </p>
          <div
            className="mt-1 gap-4"
            style={{
              display: "flex",
              width: "100%",
              // gridTemplateColumns: width > 768 ? "4fr 1.5fr" : "1fr",
              //  border: "1px solid #ccc",
            }}
          >
            <div className="w-full md:pt-0">
              {/*WELCOME SECTION*/}
              <div className="mb-12 mt-5 justify-between grid gap-5 grid-cols-1 md:grid-cols-3">
                <Card
                  title={'Total Surveys'}
                  text={summaryData?.self_reviews?.selfReviewAssigned || 0}
                  color="text-gray-900"
                  bgColor={'bg-white'}
                  isLoading={summaryLoading}
                  description={'Total self evaluations assigned to you'}
                  width="w-full"
                />
                <Card
                  title={'Pending'}
                  text={summaryData?.self_reviews?.selfReviewPending || 0}
                  bgColor={'bg-orange-50'}
                  color="text-orange-500"
                  isLoading={summaryLoading}
                  description={'Self evaluations yet to be completed'}
                  width="w-full"
                />
                <Card
                  title={'Completed'}
                  bgColor={'bg-green-50'}
                  text={summaryData?.self_reviews?.selfReviewCompleted || 0}
                  isLoading={summaryLoading}
                  color="text-[#87AA4B]"
                  description={'Total self evaluations completed'}
                  width="w-full"
                />
              </div>
              <section>
                <div className="md:flex items-center justify-between mb-3">
                  <h5 className="max-[500px]:mb-3 text-xl font-semibold" style={{ color: appearance?.theme_colour }}>
                    My Self Evaluations
                  </h5>
                  <div className="w-full md:w-[300px] text-slate-950">
                    <Input
                      type='search'
                      placeholder={'Search Surveys'}
                      onChange={event => setSearch(event.target.value)}
                    />
                  </div>
                </div>
                {
                  surveysLoading ? (
                    <Loader />
                  ) :
                    !surveys?.data?.length > 0 ? (
                      <EmptyData text={'No Surveys Found'} />
                    ) :
                      <div className="mb-12 grid gap-5 grid-cols-1 md:grid-cols-3">
                        {
                          surveys?.data?.map((survey, index) => (
                            <SurveyCard refetch={refetch} survey={survey} key={survey?.id} />
                          ))
                        }
                      </div>

                }
              </section>
              <Pagination
                data={surveys?.meta}
                perPage={perPage}
                pageNo={currentPage}
                setPageNo={setCurrentPage}
                setPerPage={setPerPage}
              />
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default SelfReview;

